import { __assign } from '../../_virtual/_tslib.js';
import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsLink/SdsLink.vue.js';
import __vue_component__$1 from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsButtonText',
    props: {
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasContainer: {
            type: Boolean,
            required: false,
            default: false,
        },
        isBlock: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconName: {
            type: String,
            required: false,
            default: '',
        },
        hasChevron: {
            type: Boolean,
            required: false,
            default: false,
        },
        type: {
            type: [String, Object],
            required: false,
            default: 'button',
        },
        background: {
            type: String,
            required: false,
            default: 'elevation',
        },
        variant: {
            type: String,
            required: false,
            default: 'primary',
        },
        size: {
            type: String,
            required: false,
            default: 'md',
        },
    },
    emits: ['click'],
    setup: function (props) {
        var componentProps = computed(function () { return typeof props.type === 'string'
            ? {
                is: 'button',
                type: props.type,
                disabled: props.isDisabled,
            }
            : __assign({ is: __vue_component__, inert: props.isDisabled, ariaDisabled: props.isDisabled ? true : null }, props.type); });
        return {
            componentProps: componentProps,
        };
    },
    components: {
        SdsLink: __vue_component__,
        SdsIcon: __vue_component__$1,
    },
});

export default script;
